// extracted by mini-css-extract-plugin
module.exports = {"container":"_32_1IO3UKXmNP2gM4lue1d"};